import React, { useState } from 'react';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { isEmpty } from 'lodash';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import FilterChip from '../../../components/FilterChip';
import BobModal from '../../../components/BobModal';
import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

import * as configurationActions from '../../../actions/configurationActions';

import * as classes from './AddNewEntityModal.module.css';
import * as configStyle from './ConfirmConfiguration.module.css';

const ConfirmConfiguration = ({
    action,
    activeConfiguration,
    configurations,
    currentUser,
    emails,
    fetchAllConfigurations,
    history,
    hideIsDefault,
    isFromConfiguratioinsTable,
    setConfigurationData,
    setMenuOpen,
    selectedConfiguration,
    toggleSaveConfigurationModal,
    updateConfiguration,
    ...props
}) => {
    // eslint-disable-next-line no-unused-vars
    const [emailList, setEmailList] = useState((selectedConfiguration && selectedConfiguration.sharedEmails) || []);

    const viewNameValidation = name => {
        const result = configurations.filter(item => item.name.toLowerCase() === name.toLowerCase().trim());
        let isValidName = false;

        // save or save as view
        if (isEmpty(result)) {
            isValidName = true;
        // edit view
        } else if (action === 'edit' && !isEmpty(selectedConfiguration)) {
            if (selectedConfiguration.id === result[0].id) {
                isValidName = true;
            } else {
                isValidName = false;
            }
        }
        
        return isValidName;
    };
    
    Yup.addMethod(Yup.string, 'viewNameValidation', function (errorMessage) {
        return this.test(`test-view-name`, function (value) {
            const { path, createError } = this;
            
            return (
                value && value.trim() ?
                    viewNameValidation(value) ||
                    createError({ path, message: 'View Name already exist' })
                    : createError({ path, message: 'This field is required' })
            );
        });
    });
    
    const ValidationSchema = Yup.object().shape({
        viewName: Yup.string()
            .max(45, 'Max length is 45 characters')
            .viewNameValidation(),
        isDefault:      Yup.boolean(),
        shareViewEmail: Yup.string()
    });

    const formik = useFormik({
        initialValues: {
            viewName:       selectedConfiguration && selectedConfiguration.name ? action === 'saveAs' ? `${selectedConfiguration.name} Copy`: selectedConfiguration.name : '' ,
            isDefault:      selectedConfiguration && selectedConfiguration.isDefault ? true : false,
            shareViewEmail: ''
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {

            values.sharedEmails = emailList;
            values.viewName = values.viewName.trim();

            if (selectedConfiguration && action === 'edit') {
                const payload =  {
                    'viewKey':      selectedConfiguration.viewKey,
                    'entityId':     selectedConfiguration.entityId,
                    'entityName':   selectedConfiguration.entityName || '',
                    'name':         values.viewName,
                    'isDefault':    values.isDefault,
                    'viewData':     JSON.stringify(selectedConfiguration.viewData),
                    'sharedEmails': emailList
                };

                await updateConfiguration(selectedConfiguration.id, payload);
                await fetchAllConfigurations(currentUser.id); 
            } else if (action === 'saveAs') {
                setConfigurationData(values);
            } else {
                setConfigurationData(values);
                setMenuOpen();
            }

            toggleSaveConfigurationModal();
        }
    });

    const handleRemove = (item) => {
        let list = emailList.filter(email => email !== item);
        setEmailList(list);
    };

    const onAddEmails = (e) => {
        const email = formik.values.shareViewEmail;

        let isValid = false;
        if (!isEmpty(emails)) {
            isValid = emails.includes(email) ? true : false;
        }
        if (isValid) {
            setEmailList([...emailList, email]);
            formik.setFieldValue('shareViewEmail', '', false);
        }
    };

    const validateEmails = () => {
        const email = formik.values.shareViewEmail;

        if (email) {
            let errorMsg = '';
            let isValidEmail = true;

            var rule = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            
            if (!rule.test(email)) {
                errorMsg = 'Invalid email';
                isValidEmail = false;
            }
            
            if (isValidEmail && !isEmpty(emails)) {
                errorMsg = emails.includes(email) ? '' : 'User does not exist';
            }

            if (isValidEmail && !isEmpty(emailList)) {
                errorMsg = emailList.includes(email) ? 'Already added this email' : '';
            }

            return errorMsg;
        }
    };

    let confirmButtonLabel = 'Save';
    let modalTitle = 'Save View & Configuration';

    if (action === 'edit') {
        confirmButtonLabel = 'Update';
        modalTitle = 'Update View & Configuration';
    } else if (action === 'saveAs') {
        modalTitle = 'Save As View & Configuration';
    }

    const errorMsg = validateEmails();

    return (
        <BobModal
            title={modalTitle}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => toggleSaveConfigurationModal()}
        >
            <div className={classes.ModalBody}>
                <div>
                    <FormControl className={classes.Row}>
                        <TextField
                            className={classes.Input}
                            id="viewName"
                            name="viewName"
                            type="text"
                            value={formik.values.viewName}
                            label={<span>View Name<span className={classes.required}> *</span></span>}
                            placeholder="View Name"
                            size="small"
                            onChange={formik.handleChange}
                            InputProps={{
                                onBlur: formik.handleBlur
                            }}
                            variant="outlined"
                            FormHelperTextProps={{
                                classes: {
                                    error: classes.error
                                }
                            }}
                            error={Boolean(formik.errors.viewName) && Boolean(formik.touched.viewName)}
                            helperText={Boolean(formik.touched.viewName) && formik.errors.viewName}
                        />
                    </FormControl>
                </div>
                {
                    !hideIsDefault ?
                        <div>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        classes={{
                                            root: classes.Checkbox
                                        }}
                                        onChange={formik.handleChange}
                                        checked={formik.values.isDefault}
                                        name="isDefault"
                                    />
                                }
                                label={
                                    <div className={classes.Font}>
                                        Set as Default View
                                    </div>
                                }
                            />
                        </div> : null
                }
                <p className={configStyle.Info}>Share this view & configuration</p>
                <div className={configStyle.ShareView}>
                    <FormControl className={configStyle.inputWrapper}>
                        <TextField
                            id="shareViewEmail"
                            name="shareViewEmail"
                            type="text"
                            value={formik.values.shareViewEmail}
                            label={'Email'}
                            onChange={formik.handleChange}
                            InputProps={{
                                onBlur: formik.handleBlur
                            }}
                            FormHelperTextProps={{
                                classes: {
                                    error: classes.error
                                }
                            }}
                        />
                        { formik.values.shareViewEmail ? <p className={configStyle.Error}>{ errorMsg }</p> : ''}
                    </FormControl>
                    <Button
                        className={classes.Button}
                        onClick={onAddEmails}
                        variant="contained"
                        disabled={errorMsg ? true : false}
                    >
                        Add
                    </Button>
                </div>
                <div className={configStyle.EmailChipsWrapper}>
                    { emailList.map((item, index) => (
                        <FilterChip
                            key={index}
                            item={item}
                            removeFilter={() => handleRemove(item)}
                        />
                    ))}
                </div>
                <div className={classes.ButtonContainer}>
                    <BobCancelButton
                        className={classes.CancelButton}
                        onClick={() => toggleSaveConfigurationModal()}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        className={classes.Buttons}
                        onClick={formik.handleSubmit}
                        label={confirmButtonLabel}
                        iconSize={15}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => {
    return {
        configurations: state.configurationData.configurations,
        currentUser:    state.currentUser,
        emails:         state.dashboard.emails,
    };
};

const mapDispatchToProps = {
    ...configurationActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmConfiguration));
